// Gestion du consentement aux cookies de mesure d'audience.
// Le choix (accepté ou refusé) est conservé 6 mois, durée maximale recommandée par la CNIL.

const STORAGE_KEY = 'cookie-consent';
const CONSENT_TTL_MS = 6 * 30 * 24 * 60 * 60 * 1000;
export const CONSENT_CHANGED_EVENT = 'cookie-consent-changed';

export const CONSENT = {
  ACCEPTED: 'accepted',
  REFUSED: 'refused',
};

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { value, date } = JSON.parse(raw);
    if (Date.now() - new Date(date).getTime() > CONSENT_TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return value;
  } catch (e) {
    return null;
  }
};

export const setConsent = (value) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, date: new Date().toISOString() }));
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: value }));
};

export const clearConsent = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: null }));
};
